export default __webpack_public_path__ + "static/media/form-register.97c5faa0.png";